import {Component} from '@angular/core';
import {ModalRef} from '../modal-ref';

@Component({
    selector: 'app-error-box',
    templateUrl: './error-box.component.html',
    styleUrls: ['./error-box.component.scss'],
    standalone: false
})
export class ErrorBoxComponent {
    text = '';
    title = '';

    constructor(private modal: ModalRef) {
        this.text = modal.data.text;
        this.title = modal.data.title ?? $localize`:@@popup.error.mainTitle:Etwas ist schiefgelaufen`;
    }

    ok(): void {
        this.modal.close();
    }
}
